import React from "react";
import HeaderScrolled from "../HeaderScrolled/HeaderScrolled";
import { Header2Wrapper } from "./Header2.styled";

const Header2 = ({ onOpenChat }) => {
  return (
    <Header2Wrapper>
      <HeaderScrolled onChatClick={onOpenChat} />
    </Header2Wrapper>
  );
};

export default Header2;
